<template>
  <div class="electrode-content">
    <div class="electrode-row">
      <div class="electrode-col electrode-text">
        <h3 style="color: #FFFFFF;margin-bottom: 20px;">
          AI Body Posture Risk and Circumference Measurement <br />
        </h3>
        <p>
          We utilize AI image analysis technology to determine the precise location and dimensions of skeletal points, combined with accurate body composition data, such as muscle and fat content in various body parts. This allows us to precisely analyze body posture risks and body circumference measurements.
        </p>
      </div>
      <div class="electrode-col electrode-bg2">
        <div class="body-box">
          <img src="/static/images/body-guge.png"/>
        </div>
        <div class="electrode-desc">
          <!-- Additional content can be added here -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIPostureAnalysis'
}
</script>

<style scoped>
/* 组件特定样式 */
</style>